import {prefix} from "../../../utils/constant"

export const getTableColumnWidthHistory = function (tableId) {
  const tableCloumnWidthStr = window.localStorage.getItem(`${prefix}-${tableId}-table-column-width`)

  return tableCloumnWidthStr ? JSON.parse(tableCloumnWidthStr) : {}
}

export const setTableColumnWidthHistory = function (tableId, tableCloumnWidthHistory) {
  window.localStorage.setItem(`${prefix}-${tableId}-table-column-width`, JSON.stringify(tableCloumnWidthHistory))
}